import { Attr } from '@mode-switch/model';
import { DataType } from '@mode-switch/express';

export const ICON_FIELD_MAP: { [key: string]: string } = {
  BOOLEAN: 'icon-field-boolean',
  CALCBOOLEAN: 'icon-field-calc-boolean',
  CALCTIMESTAMP: 'icon-field-calc-date',
  CALCINTEGER: 'icon-field-calc-numeric',
  CALCFLOAT: 'icon-field-calc-numeric',
  CALCSTRING: 'icon-field-calc-string',
  CALCDATE_TIME: 'icon-field-calc-date',
  DATE_TIME: 'icon-field-date',
  TIMESTAMP: 'icon-field-date',
  FLOAT: 'icon-field-numeric',
  INTEGER: 'icon-field-numeric',
  STRING: 'icon-field-string',
  FX: 'icon-fx',
  TABLECAL: 'icon-field-quick-cal',
};
export function getFieldIcon(fieldDataType: DataType.Name | undefined, hasCalcAttr: boolean): string {
  if (fieldDataType) {
    return hasCalcAttr ? ICON_FIELD_MAP[`${Attr.Source.Calc}${fieldDataType}`] : ICON_FIELD_MAP[fieldDataType];
  } else {
    return '';
  }
}
